import { FormPreventDefault } from 'components/Form';
import React, { FormEventHandler, FunctionComponent } from 'react';
import { Modal as BModal } from 'react-bootstrap';
import Button from '../Button';

interface Props {
  cancelText?: string;
  confirmText?: string;
  onClose: () => void;
  onConfirm: FormEventHandler;
  confirming?: boolean;
  show: boolean;
  size?: 'sm' | 'lg' | 'xl';
  title?: string;
  showFooter?: boolean;
  showConfirmButton?: boolean;
  showCancelButton?: boolean;
  disableConfirmButton?: boolean;
  preventBackgroundClick?: boolean;
  hideCloseX?: boolean;
  contentClassName?: string;
}

const Modal: FunctionComponent<Props> = ({
  children,
  cancelText = 'Cancel',
  confirmText = 'Done',
  onClose,
  onConfirm,
  confirming,
  show,
  size,
  title,
  showConfirmButton = true,
  showCancelButton = true,
  preventBackgroundClick = false,
  hideCloseX = false,
  contentClassName,
  disableConfirmButton = false
}) => {
  return (
    <BModal show={show} onHide={onClose} centered size={size} backdrop={preventBackgroundClick ? 'static' : true} className={hideCloseX ? 'hide-close' : ''} keyboard={!hideCloseX} contentClassName={contentClassName}>
      <BModal.Header closeButton>
        {title && <BModal.Title className="fw-normal">{title}</BModal.Title>}
      </BModal.Header>
      <BModal.Body>{children}</BModal.Body>
      <BModal.Footer>
        {showCancelButton && (
          <Button variant="link" onClick={onClose}>
            {cancelText}
          </Button>
        )}
        {showConfirmButton && (
          <Button variant="primary" onClick={onConfirm} loading={confirming} disabled={disableConfirmButton} text="Saving...">
            {confirmText}
          </Button>
        )}
      </BModal.Footer>
    </BModal>
  );
};

const FormModal: FunctionComponent<Props> = ({
  children,
  cancelText = 'Cancel',
  confirmText = 'Done',
  onClose,
  onConfirm,
  confirming,
  show,
  size,
  title,
  showConfirmButton = true,
  showCancelButton = true,
  disableConfirmButton = false,
  contentClassName,
  preventBackgroundClick = false
}) => {
  return (
    <BModal show={show} onHide={onClose} centered size={size} contentClassName={contentClassName} backdrop={preventBackgroundClick ? 'static' : true}>
      <FormPreventDefault onSubmit={onConfirm}>
        <BModal.Header closeButton>
          {title && <BModal.Title className="fw-normal">{title}</BModal.Title>}
        </BModal.Header>
        <BModal.Body>{children}</BModal.Body>
        <BModal.Footer>
          {showCancelButton && (
            <Button variant="link" onClick={onClose}>
              {cancelText}
            </Button>
          )}
          {showConfirmButton && (
            <Button variant="primary" type="submit" disabled={disableConfirmButton} loading={confirming} text="Saving...">
              {confirmText}
            </Button>
          )}
        </BModal.Footer>
      </FormPreventDefault>
    </BModal>
  );
};

export { Modal, FormModal };
